import { render, staticRenderFns } from "./Recart.vue?vue&type=template&id=56568ace"
import script from "./Recart.vue?vue&type=script&lang=ts"
export * from "./Recart.vue?vue&type=script&lang=ts"
import style0 from "./Recart.vue?vue&type=style&index=0&id=56568ace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports